import * as Sentry from '@sentry/react';
import { createBrowserRouter, createRoutesFromElements, Route, useRouteError } from 'react-router';
import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useProfileV2 } from 'core/lib/Profile';
import AppWrapper from '#components/AppWrapper/AppWrapper';
import { ErrorPage } from '#components/Error';
import { FollowupRouteTree } from './followupRouteTree';
import { AdminRouteTree } from './adminRouteTree';
import { PickupsRouteTree } from './pickupRouteTree';
import { PortalHomeRouteTree } from './homeRouteTree';
import { CO2ImpactRouteTree } from './co2ImpactRouteTree';
import { CSRDRouteTree } from './csrdRouteTree';
import { EnvironmentRouteTree } from './environmentRouteTree';
import { LearningRouteTree } from './learningRouteTree';

const RouterErrorBoundary = () => {
  const error = useRouteError();
  const { isAuthenticated } = useAuth0();

  const { basicProfile } = useProfileV2();

  if (basicProfile) {
    Sentry.setUser({
      email: basicProfile.email,
      id: basicProfile.email,
    });
  }

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  return <ErrorPage errorType="SOMETHING_WENT_WRONG" includeAppContainer={isAuthenticated} />;
};

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<AppWrapper />} ErrorBoundary={RouterErrorBoundary}>
      {...PortalHomeRouteTree}
      {PickupsRouteTree}
      {CO2ImpactRouteTree}
      {FollowupRouteTree}
      {EnvironmentRouteTree}
      {CSRDRouteTree}
      {AdminRouteTree}
      {LearningRouteTree}

      <Route path="*" element={<ErrorPage errorType="PAGE_NOT_FOUND" />} />
    </Route>,
  ),
);
